import { Component, DestroyRef, effect, inject, input, model, OnInit, output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { groupBy, GroupResult } from '@progress/kendo-data-query';

import { IUnit } from '@app/core/models/unit.model';
import { UnitService } from '@app/core/services/http-services/common/unit-service';
import { _, TranslateDirective } from "@ngx-translate/core";
import { DropDownSize, DropDownListComponent, GroupTemplateDirective } from '@progress/kendo-angular-dropdowns';

import { LabelComponent } from '@progress/kendo-angular-label';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

_('App.UnitCode');

@Component({
    selector: 'app-select-unit',
    template: `
  @if (showLable()) {
    <kendo-label translate>{{label()}}</kendo-label>
  }
  <kendo-dropdownlist
    [data]="units"
    [size]="size()"
    textField="unitCode"
    valueField="unitCode"
    [showStickyHeader]="false"
    [loading]="loading"
    [disabled]="isDisabled()"
    [valuePrimitive]="true"
    [(value)]="selectedUnitCode"
    (selectionChange)="onChangedVal($event)"
    [popupSettings]="{ popupClass: 'removeHeader' }"
    class="c">
    <ng-template kendoDropDownListGroupTemplate let-group> </ng-template>
  </kendo-dropdownlist>
  `,
    styleUrls: ['./select-unit.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectUnitComponent
        }
    ],
    imports: [LabelComponent, TranslateDirective, DropDownListComponent, GroupTemplateDirective]
})
export class SelectUnitComponent implements OnInit, ControlValueAccessor {
  units: GroupResult[] = [];
  selectedUnitCode:string = 'M3';
  loading:boolean = true;

  label = input<string>('App.UnitCode');
  isDisabled = model<boolean>(false);
  showLable = input<boolean>(false);
  selectedUnitCodeInput = input<string | undefined>(undefined);
  size = input<DropDownSize>('medium');

  onUnitChange = output<string>();

  private onChanged: Function = () => {};
  private onTouched: Function = () => {};
  private readonly destroyRef = inject(DestroyRef);
  private readonly unitService = inject(UnitService);

  constructor() {
    effect(() => {
      if (this.selectedUnitCodeInput()) {
        this.selectedUnitCode = this.selectedUnitCodeInput();
      }
    });
  }

  ngOnInit(): void {
    this.loadUnit();
  }

  onChangedVal(unit:IUnit) {
    this.selectedUnitCode = unit != null ? unit.unitCode : '';
    this.onUnitChange.emit(this.selectedUnitCode);
    this.onTouched();
    this.onChanged(this.selectedUnitCode);
  }

  writeValue(unitCode: string): void {
    this.selectedUnitCode = unitCode;
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  private loadUnit() {
    this.unitService.query({}).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(u => {
      this.units = (groupBy(u, [{ field: 'mandatoryUnitRelation' }]) as GroupResult[]).sort(
        (a: GroupResult, b: GroupResult) => Number(b.value) - Number(a.value));

      this.loading = false;
    });
  }
}
